
import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import "../Dashboard.css"
import { useState } from "react";
import ProjectEvalution from "../Vendor/ProjectEvaluations/ProjectEvalution";
import TableBody from "@mui/material/TableHead";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import { getOrgType } from "../../../utils/Token";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import CloseIcon from '@mui/icons-material/Close';
import axios from "../../../utils/fvAxios";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import ClientEvaluationsDataEntry from "./ClientEvaluationsDataEntry";


export default function ClientEvaluationsList(props) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
    },

    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const { t } = useTranslation();


  const [view, setView] = useState(true);
  const [ReviewInputId, setReviewInputId] = useState("");
  const [EditId, setEditId] = useState("");
  const Viewed = (r, num) => {
    setEditId(num);
    setReviewInputId(r);
    setView(view => !view);
  }
  const BackEvaluationList = () => {
    setView(view => !view);
  }

  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");

  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [DeleteRatingId, setDeleteRatingId] = useState("");
  const Deletedialogbox = (e) => {
    setDeleteRatingId(e);
    setDeleteDialog(true);
  };

  const DeleteSite = async () => {
    const res = await axios.post("Prequalification/DeleteContractorReview?reviewId=" + DeleteRatingId);
    if (res?.data?.responseCode === 100) {
      setDeleteDialog(false);
      props.Recall(true);
    } else {
      setDeleteDialog(true);
      toast.error(res?.data?.responseMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

  };
  const DeletedialogboxClose = () => {
    setDeleteDialog(false);
  };


  // const RemoveRating = async (val) => {
  //   const res = await axios.post("Prequalification/DeleteContractorReview?reviewId=" + DeleteRatingId);
  //   if (res?.data?.responseCode === 100) {
  //     props.Recall(true);
  //   }
  // }
  return (
    <>
      {!view && ((getOrgType() == "Client" && EditId == 2) ?
        <ClientEvaluationsDataEntry ReviewInputId={ReviewInputId} EvlVendorsList={props?.evalutedVendors} BackEvaluationList={BackEvaluationList} />
        : <ProjectEvalution ReviewInputId={ReviewInputId} BackEvaluationList={BackEvaluationList} />)}
      <ToastContainer />
      <Dialog
        open={DeleteDialog}
        keepMounted
        onClose={DeletedialogboxClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle> Are are sure you want delete this item?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This means the selected item is going to be lost forever.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={DeletedialogboxClose}>DisAgree</Button>
          <Button onClick={DeleteSite}>Agree</Button>
        </DialogActions>
      </Dialog>

      <TableContainer component={Paper} style={{ display: !view ? "none" : "block" }}>
        <Box hidden={getOrgType() != "Admin" || props?.evalaution?.contractorEvaluations?.length == 0}>
          <h4 className="mx-3 my-3" variant="contained">

            {t('VendorDetails.label26')}
          </h4>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell> {t('VendorDetails.label27')}</StyledTableCell>
                <StyledTableCell align="left"> {t('VendorDetails.label28')}</StyledTableCell>
                <StyledTableCell align="left" > {t('VendorDetails.label29')}</StyledTableCell>
                <StyledTableCell align="left" > {t('VendorDetails.label37')}</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {props?.evalaution?.contractorEvaluations?.map((r, i) => (
                <TableRow key={i} sx={{
                  "&:last-child td": {
                    border: 0,
                  },
                  backgroundColor: "#fff"
                }}>
                  <TableCell sx={{ width: "30%", color: "#2A93DB" }}><a style={{ cursor: "pointer" }} onClick={() => Viewed(r.vendorReviewInputId, 1)}>{r?.reviewType}</a></TableCell>
                  {/* {r.vendorReviewInputId} */}
                  <TableCell sx={{ width: "25%", backgroundColor: "#fff" }} >
                    <Box
                      sx={{
                        width: 200,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ mr: 2, color: "#2A93DB" }}>{r?.userRating}</Box>
                      <Rating
                        name="text-feedback"
                        value={r?.userRating}
                        readOnly
                        max={3}
                        precision={0.5}
                        sx={{ color: "#2A93DB" }}
                        emptyIcon={
                          <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
                        }
                      />
                    </Box>
                  </TableCell>
                  <TableCell sx={{ width: "25%" }}>
                    {r?.inputUserName}
                  </TableCell>

                  <TableCell sx={{ width: "35%" }}>
                    {GetfVDateFormate(r?.reviewedOn)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </Box>

        <Box hidden={getOrgType() != "Client" || props?.evalaution?.myEvaluations?.length == 0}>
          <h4 className="mx-3 my-3" variant="contained">
            {t('VendorDetails.label36')}
          </h4>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell> {t('VendorDetails.label27')}</StyledTableCell>
                <StyledTableCell align="left"> {t('VendorDetails.label28')}</StyledTableCell>
                <StyledTableCell align="left" > {t('VendorDetails.label29')}</StyledTableCell>
                <StyledTableCell align="left" > {t('VendorDetails.label37')}</StyledTableCell>
                <StyledTableCell align="left" > &nbsp;</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {props?.evalaution?.myEvaluations?.map((r, i) => (
                <TableRow key={i} sx={{
                  "&:last-child td": {
                    border: 0,
                  },
                  backgroundColor: "#fff"
                }}>
                  <TableCell sx={{ width: "32%", color: "#2A93DB" }}><a style={{ cursor: "pointer" }} onClick={() => Viewed(r.vendorReviewInputId, 2)}>{r?.reviewType}</a></TableCell>
                  {/* {r.vendorReviewInputId} */}
                  <TableCell sx={{ width: "26%", backgroundColor: "#fff" }} >
                    <Box
                      sx={{
                        width: 200,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ mr: 2, color: "#2A93DB" }}>{r?.userRating}</Box>
                      <Rating
                        name="text-feedback"
                        value={r?.userRating}
                        readOnly
                        max={3}
                        precision={0.5}
                        sx={{ color: "#2A93DB" }}
                        emptyIcon={
                          <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
                        }
                      />
                    </Box>
                  </TableCell>
                  <TableCell sx={{ width: "27%" }}>
                    {r?.inputUserName}
                  </TableCell>
                  <TableCell sx={{ width: "40%" }}>
                    {GetfVDateFormate(r?.reviewedOn)}
                  </TableCell>
                  <TableCell sx={{ width: "10%" }}>
                    <span className='mx-2' onClick={() => Deletedialogbox(r?.vendorReviewInputId)} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </Box>

        <Box hidden={getOrgType() != "Client" || props?.evalaution?.otherEvaluations?.length == 0}>
          <h4 className="mx-3 my-3" variant="contained">
            {t('VendorDetails.label26')}
          </h4>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell> {t('VendorDetails.label27')}</StyledTableCell>
                <StyledTableCell align="left"> {t('VendorDetails.label28')}</StyledTableCell>
                <StyledTableCell align="left" > {t('VendorDetails.label29')}</StyledTableCell>
                <StyledTableCell align="left" > {t('VendorDetails.label37')}</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {props?.evalaution?.otherEvaluations?.map((r, i) => (
                <TableRow key={i} sx={{
                  "&:last-child td": {
                    border: 0,
                  },
                  backgroundColor: "#fff"
                }}>
                  <TableCell sx={{ width: "30%", color: "#2A93DB" }}><a style={{ cursor: "pointer" }} onClick={() => Viewed(r.vendorReviewInputId, 1)}>{r?.reviewType}</a></TableCell>
                  {/* {r.vendorReviewInputId} */}
                  <TableCell sx={{ width: "25%", backgroundColor: "#fff" }} >
                    <Box
                      sx={{
                        width: 200,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ mr: 2, color: "#2A93DB" }}>{r?.userRating}</Box>
                      <Rating
                        name="text-feedback"
                        value={r?.userRating}
                        readOnly
                        max={3}
                        precision={0.5}
                        sx={{ color: "#2A93DB" }}
                        emptyIcon={
                          <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
                        }
                      />
                    </Box>
                  </TableCell>
                  <TableCell sx={{ width: "25%" }}>
                    {r?.inputUserName}
                  </TableCell>

                  <TableCell sx={{ width: "35%" }}>
                    {GetfVDateFormate(r?.reviewedOn)}
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <div className="mx-3 mt-3">
          <Button sx={{ float: "right", marginBottom: "10px", textTransform: "capitalize", padding: "15px" }} id="buttonvalution" variant="contained" href={"/vendordetails?pqid=" + PQID}>{t('VendorDetails.label30')}</Button>
        </div>
      </TableContainer>


    </>
  );
}